import { useDisciplineStore } from '@stores/discipline'
import { useSubscriptionStore } from '@stores/subscription'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

export const useSubscriptionListApi = async (): Promise<any> => {
  const { $axios } = useNuxtApp()

  const disciplineStore = useDisciplineStore()
  const subscriptionStore = useSubscriptionStore()

  const id = disciplineStore.activeDiscipline?.id || null

  if (id) {
    const url = useCsRoutes('subscription.list', {
      '[discipline_id]': id,
    })
    try {
      const { data } = await $axios.get(url!)

      subscriptionStore.setSubscriptions(data.data)

      return data.data
    } catch (err) {
      console.error(err)
      return null
    }
  } else {
    return null
  }
}
